<template lang="pug">
div
    .abs.wh100p.orange.lighten-4
    v-container
        v-layout(row wrap).pa-2
            v-btn.mx-1.my-2(dark).red 帳號：{{account}}
            v-btn.mx-1.my-2(dark).pink 姓名：{{name}}
            //- v-btn.mx-1.my-2(dark).purple 目前位置：{{lat}}, {{lng}}
            //- v-btn.mx-1.my-2(dark).green
            //-     v-radio-group(row v-model="condition")
            //-         v-radio(label="打卡" value="打卡")
            //-         v-radio(label="填寫" value="填寫")
            //-         v-radio(label="登入" value="登入")
            //-         v-radio(label="全部" value="")
        v-timeline(:dense="dense")
            v-timeline-item(v-for="(hist,i) in filterHistory" :key="i" fill-dot :color="colors[i%colors.length]")
                v-card(dark)
                    v-card-title(:style="{background:colors[i%colors.length]}")
                        div(v-if="hist.item.substr(0,2)=='打卡'") {{hist.item.split(' ')[0]}}
                            a(:href="'https://maps.google.com/?q='+hist.item.split(' ')[1]" target="_blank").white--text.ml-2 {{hist.item.split(' ')[1]}}
                        div(v-else) {{hist.item}}
                        v-spacer
                        v-icon(dark @click="removeHistory(hist.time)") mdi-close
                    v-card-text.pt-3
                        v-icon mdi-calendar-range
                        span {{hist.time.split(' ')[0]}}
                        v-icon.ml-3 mdi-clock
                        span {{hist.time.split(' ')[1]}}
        
        //- v-layout.psf
        //-     v-tooltip(top)
        //-         template(v-slot:activator="{ on }")
        //-             v-btn.ma-1(fab dark @click="status='上車';checkIn()" v-on="on").indigo
        //-                 v-icon mdi-airplane-takeoff
        //-         span 上車
        //-     v-tooltip(top)
        //-         template(v-slot:activator="{ on }")
        //-             v-btn.ma-1(fab dark @click="status='下車';checkIn()" v-on="on").indigo
        //-                 v-icon mdi-airplane-landing
        //-         span 下車
        //-     v-tooltip(top)
        //-         template(v-slot:activator="{on}")
        //-             v-btn.ma-1(fab dark @click="status='站點';checkIn()" v-on="on").indigo
        //-                 v-icon mdi-map-marker
        //-         span 站點
</template>

<script>
import { db, colors } from '../main';
// import bgimg from '@/assets/bg-img.jpg';
import { doc, getDoc, updateDoc } from '@firebase/firestore';
export default {
    name: 'check_in',
    data() {
        return {
            bg_style: {
                width: '100%',
                height: '100%',
                background: `url(${bgimg})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                filter: 'blur(5px)',
            },
            account: 'XXXOOO',
            name: 'OOO',
            status: '上車',
            lat: '',
            lng: '',
            checks: [],
            history: [],
            dense: false,
            colors: colors.map(x=>x.p),
            condition: '',
        };
    },
    methods: {
        checkIn() {
            navigator.geolocation.getCurrentPosition(
                (e) => {
                    this.lat = e.coords.latitude.toFixed(6);
                    this.lng = e.coords.longitude.toFixed(6);
                    let date = new Date().toLocaleString();
                    this.updateHistory(date);
                },
                () => {
                    alert('無法取得座標點，請確定是否已開啟衛星定位功能');
                }
            );
        },
        removeHistory(time) {
            const history = this.history.filter((x) => x.time != time);
            updateDoc(doc(db, '會員', this.account), { history }).then(() => {
                this.history = history;
            });
        },
        updateHistory(date) {
            const ref = doc(db, '會員', this.account);
            getDoc(ref).then((res) => {
                const newData = { time: date, item: '打卡' + this.status + ' ' + this.lat + ',' + this.lng };
                const history = [newData, ...res.data().history];
                updateDoc(ref, { history }).then(() => {
                    this.history = history;
                });
            });
        },
    },
    computed: {
        filterHistory() {
            if (this.condition) return this.history.filter((x) => x.item.includes(this.condition));
            else return this.history;
        },
    },
    mounted() {
        this.account = this.$store.state.user.account;
        this.name = this.$store.state.user.name;
        navigator.geolocation.getCurrentPosition((e) => {
            this.lat = e.coords.latitude.toFixed(6);
            this.lng = e.coords.longitude.toFixed(6);
        });
        getDoc(doc(db, '會員', this.account)).then((res) => {
            this.history = res.data().history;
        });
        this.dense = window.innerWidth < 760 ? true : false;
        addEventListener('resize', () => {
            this.dense = window.innerWidth < 760 ? true : false;
        });
    },
};
</script>
